import { GhccPlayerEventCode, GhccRequestSuffix } from '@/models/Ghcc';

import fetch from '@/utils/fetch';

import {
  getCoursePlayerEventEndpoint,
  getCoursePlayerRatingEndpoint,
  getGhccSsoEndpoint,
  getGhccStartActivityEndpoint,
} from './endpoints';

/**
 * Util for making the /api/ghccSso request and returning the url
 * @param courseId - number
 * @param sessionId - string
 * @returns url - string
 */
export const getGhccSsoUrl = async (courseId: number, sessionId: string): Promise<string> => {
  const requestData = { courseId, sessionId, suffix: GhccRequestSuffix.Sso };

  const response = await fetch(getGhccSsoEndpoint(), {
    method: 'POST',
    body: JSON.stringify(requestData),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  const responseData = await response.json();

  return responseData.url;
};

/**
 * Util for making the /api/ghccStartActivity request
 * @param activityId - string
 * @param sessionId - string
 * @returns
 */
export const startActivityRequest = async (activityId: string, sessionId: string) => {
  const requestData = {
    suffix: GhccRequestSuffix.StartActivity,
    moduleId: activityId,
    sessionId,
  };

  const response = await fetch(getGhccStartActivityEndpoint(), {
    method: 'POST',
    body: JSON.stringify(requestData),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return await response.json();
};

export const getPlayerEventCode = (
  shouldStartNextActivity: boolean,
  isRated: boolean,
  isAutoplayDisabled: boolean,
) => {
  if (!shouldStartNextActivity) {
    return isRated ? GhccPlayerEventCode.RatedClose : GhccPlayerEventCode.NotRatedClose;
  }

  if (isAutoplayDisabled) {
    return isRated ? GhccPlayerEventCode.RatedNext : GhccPlayerEventCode.NotRatedNext;
  }

  return isRated ? GhccPlayerEventCode.RatedAutoNext : GhccPlayerEventCode.NotRatedAutoNext;
};

export const playerEventRequest = async (EventCode: GhccPlayerEventCode, CourseCode: string) => {
  const requestData = { EventCode, CourseCode };

  await fetch(getCoursePlayerEventEndpoint(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(requestData),
  });
};

export const playerRatingRequest = async (coursecode: string, rating: number) => {
  const requestData = { coursecode, rating };

  await fetch(getCoursePlayerRatingEndpoint(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(requestData),
  });
};
